module.exports = __webpack_public_path__ + "static/img/Geos-2022-Paola.725f2b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Geos-2022-Paola.png
// module id = 7gIg
// module chunks = 0